import { Globe2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageSwitcher({ className = "" }) {
  const { language, setLanguage, languages, t } = useLanguage();

  return (
    <div className={`inline-flex items-center gap-1 rounded-xl border border-border/70 bg-background/90 p-1 shadow-sm backdrop-blur ${className}`} aria-label={t("language.choose")} data-testid="language-switcher">
      <Globe2 size={14} className="ml-1.5 mr-0.5 text-muted-foreground" aria-hidden="true" />
      {languages.map((item) => (
        <button
          key={item.code}
          type="button"
          onClick={() => setLanguage(item.code)}
          className={`rounded-lg px-2 py-1 text-[11px] font-semibold transition-colors ${language === item.code ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}
          aria-pressed={language === item.code}
          title={item.label}
          data-testid={`language-${item.code}`}
        >
          {item.short}
        </button>
      ))}
    </div>
  );
}
